import { createAction, handleActions } from 'redux-actions';
import { API_SUCCESSION_KEY_JOBS } from 'constants/apiRoutes';
import { SUCCESSION_KEY_JOBS_DEFAULT_PARAMS } from 'constants/pages';
import http from 'utility/http';
import { parseDuplicateParameters } from 'utility/uiUtils';

// ------------------------------------
// Constants
// ------------------------------------

const SET_SUCCESSION_KEY_JOBS = 'SET_SUCCESSION_KEY_JOBS';
const LOAD_MORE_SUCCESSION_KEY_JOBS = 'LOAD_MORE_SUCCESSION_KEY_JOBS';

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  keyJobs: {},
};

// ------------------------------------
// Actions
// ------------------------------------

const setSuccessionKeyJobs = createAction(SET_SUCCESSION_KEY_JOBS);
const loadMoreSuccessionKeyJobs = createAction(LOAD_MORE_SUCCESSION_KEY_JOBS);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_SUCCESSION_KEY_JOBS]: (state, { payload }) => ({ ...payload }),
  [LOAD_MORE_SUCCESSION_KEY_JOBS]: (state, { payload }) => ({
    ...state,
    ...payload,
    results: state.results
      ? [...state.results, ...payload.results]
      : [...payload.results],
  }),
};

// ------------------------------------
// API calls
// ------------------------------------

export const getSuccessionKeyJobs = (
  dispatch,
  isLoadMore = false,
  params = {}
) =>
  http
    .get(API_SUCCESSION_KEY_JOBS, {
      params: { ...SUCCESSION_KEY_JOBS_DEFAULT_PARAMS, ...params },
      paramsSerializer: data => parseDuplicateParameters(data),
    })
    .then(({ data }) => {
      return dispatch(
        isLoadMore
          ? loadMoreSuccessionKeyJobs(data)
          : setSuccessionKeyJobs(data)
      );
    });

export default handleActions(reducers, initialState);

// ------------------------------------
// "plain" action functions
// ------------------------------------

export const clearSuccessionKeyJobs = () =>
  setSuccessionKeyJobs(initialState.keyJobs);
